import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 lg:px-10 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="font-heading font-semibold text-foreground-900 mb-4 text-base">
              BaseTao Sheet
            </h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              The #1 resource hub for BaseTao Spreadsheet guides, reviews, shipping cost analysis, and expert buying strategies.
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 mb-4 text-base">
              Quick Links
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/blog/basetao-spreadsheet-complete-guide" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  Complete Guide
                </Link>
              </li>
              <li>
                <a href="#reviews" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  Reviews
                </a>
              </li>
              <li>
                <a href="#faq" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 mb-4 text-base">
              Categories
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  Shoes
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  Hoodies &amp; Sweaters
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  T-Shirts
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  Jackets
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 mb-4 text-base">
              Visit Main Site
            </h4>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              BaseTao Spreadsheet
              <i className="ri-arrow-right-up-line ml-1.5 w-4 h-4 flex items-center justify-center"></i>
            </a>
          </div>
        </div>

        <div className="border-t border-background-200/70 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-foreground-500">
            &copy; {new Date().getFullYear()} BaseTao Sheet. All rights reserved. This is an independent resource hub.
          </p>
          <div className="flex items-center gap-4">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
              Main Website
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}